import axios from "axios";

// The prefix mapping is shared by customer lookup, points, and checkout.
const CUSTOMER_PHONE_PREFIX_MAP = {
  "0120": "070", "0121": "079", "0122": "077", "0126": "076", "0128": "078",
  "0123": "083", "0124": "084", "0125": "085", "0127": "081", "0129": "082",
  "0162": "032", "0163": "033", "0164": "034", "0165": "035", "0166": "036",
  "0167": "037", "0168": "038", "0169": "039", "0186": "056", "0188": "058", "0199": "059",
};

export const normalizeCustomerPhoneToLocal = (value) => {
  if (typeof value !== "string") return null;
  let phone = value.trim().replace(/[\s\-().]/g, "");
  if (/^\+?84\d+$/.test(phone)) phone = `0${phone.replace(/^\+?84/, "")}`;
  if (!/^0\d{9,10}$/.test(phone)) return null;
  for (const [oldPrefix, newPrefix] of Object.entries(CUSTOMER_PHONE_PREFIX_MAP)) {
    if (phone.length === 11 && phone.startsWith(oldPrefix)) return `${newPrefix}${phone.slice(oldPrefix.length)}`;
  }
  return phone;
};

export const getCustomerPhoneCandidates = (value) => {
  const phone = normalizeCustomerPhoneToLocal(value);
  if (!phone) return [];
  const phones = new Set([phone]);
  for (const [oldPrefix, newPrefix] of Object.entries(CUSTOMER_PHONE_PREFIX_MAP)) {
    if (phone.length === 10 && phone.startsWith(newPrefix)) phones.add(`${oldPrefix}${phone.slice(3)}`);
  }
  const candidates = [];
  for (const local of phones) candidates.push(local, `84${local.slice(1)}`, `+84${local.slice(1)}`);
  return [...new Set(candidates)];
};

export const customerRequestOptions = (options = {}) => {
  const token = localStorage.getItem("token");
  return { ...options, headers: { ...(options.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) } };
};

export const findCustomerByPhone = async (baseUrl, phone, options = {}) => {
  const candidates = getCustomerPhoneCandidates(phone);
  if (!candidates.length) throw new Error("Số điện thoại không hợp lệ.");
  for (const candidate of candidates) {
    try {
      const response = await axios.get(`${baseUrl}/customers`, customerRequestOptions({ ...options, params: { phone: candidate } }));
      const customers = Array.isArray(response.data) ? response.data : [];
      if (customers.length > 1) throw new Error("Có nhiều hồ sơ khách hàng; cần quản trị viên đối soát.");
      if (customers[0]) return customers[0];
    } catch (error) {
      if (error.response?.status !== 404) throw error;
    }
  }
  return null;
};

export const newCustomerRequestId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  if (!window.crypto?.getRandomValues) throw new Error("Trình duyệt không hỗ trợ tạo mã giao dịch an toàn.");
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, value => value.toString(16).padStart(2, "0")).join("");
};

export const saveCustomerSale = async (baseUrl, body) => {
  // Retain the key after a lost response; resending the same sale must not create another bill.
  const fingerprint = JSON.stringify(body);
  const storageKey = `pendingCustomerSale:${body.billDetails.storeId}`;
  let pending;
  try { pending = JSON.parse(sessionStorage.getItem(storageKey) || "null"); } catch { pending = null; }
  if (!pending || pending.fingerprint !== fingerprint) {
    pending = { requestId: newCustomerRequestId(), fingerprint };
    sessionStorage.setItem(storageKey, JSON.stringify(pending));
  }
  const response = await axios.post(`${baseUrl}/saveToDb`, { ...body, requestId: pending.requestId }, customerRequestOptions());
  return response;
};

export const completeCustomerSale = (storeId) => sessionStorage.removeItem(`pendingCustomerSale:${storeId}`);
